<template>
  <div>
    <div class="home-search" :class="{ modified: modifyStyle }">
      <el-select
        class="my-el-select"
        v-model="value"
        placeholder="请选择"
        style="width: 110px; height: 40px"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-input
        class="my-input-home"
        v-model="crewValue"
        placeholder="请输入你想要搜索的职位"
      ></el-input>
      <el-button type="primary" class="my-button-home" @click="jobSearch"
        >搜索</el-button
      >
    </div>
    <p class="search-p" :class="{ 'search-white': modifyStyle }"></p>
    <div class="job-bottom">
      <div class="job-content">
        <div class="job-search">
          <div class="job-pro">排序方式:</div>
          <div
            :class="
              sortIndex == 0
                ? 'job-new'
                : sortIndex == 1
                ? 'job-old'
                : 'job-new'
            "
            @click="changeSort(0)"
          >
            默认
          </div>
          <div
            :class="
              sortIndex == 0
                ? 'job-old'
                : sortIndex == 1
                ? 'job-new'
                : 'job-old'
            "
            @click="changeSort(1)"
          >
            最新
          </div>
        </div>
        <div class="jobs-list" v-for="(item, index) in jobList" :key="index">
          <div class="jobs-title">
            <div class="jobs-font">{{ item.positionName }}</div>
            <div class="jobs-prize" v-if="!item.mianyi">
              {{ item.salaryBegin }}-{{ item.salaryEnd }}万元
            </div>
            <div class="jobs-prize" v-if="item.mianyi">
              {{ item.mianyi }}
            </div>
          </div>
          <div class="jobs-minu">
            <div class="jobs-tags">
              <span>{{ item.shipTypeName }}</span
              ><span>{{ item.recuritShipTon }}吨</span
              ><span
                >{{ item.workingYearBegin }}-{{
                  item.workingYearEnd
                }}航海经验</span
              ><span
                >{{ item.locationProvinceName }}-{{
                  item.locationPortName
                }}</span
              >
            </div>
            <div class="jobs-time">
              <span>{{ item.companyName }}</span
              ><span>{{ item.refreshTime }}</span>
            </div>
          </div>
          <div class="jobs-fuli">
            <div class="fuli-list">
              <p v-if="item.welfareTag.length == 0"></p>
              <div v-for="val in item.welfareTag" :key="val">{{ val }}</div>
            </div>
            <div class="chaka-bottom" @click="gotoJob(item)">查看职位</div>
          </div>
        </div>
        <div class="no-data text-center" v-if="jobList.length == 0">
          <img src="@/assets/nodata.png" alt="" />
        </div>
        <div class="page-aiton" v-if="total > 0">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
      <div class="job-right">
        <div class="more-title">
          <div class="more-line"></div>
          <div class="more-font">培训推荐</div>
        </div>
        <div
          class="more-train"
          v-for="(item, index) in trainList"
          :key="index"
          @click="gotoTrain(item)"
        >
          <div class="train-title">{{ item.trainTitle }}</div>
          <div class="train-tags">
            <div>热门培训</div>
            <div>名额有限</div>
          </div>
          <div class="train-dec">
            <div class="train-prize">{{ item.trainPrice }}元</div>
            <div class="train-day">
              剩<span
                :style="{ color: item.planNum <= 5 ? '#ef5151' : '#2aba48' }"
                style="margin: 0 4px"
                >{{ item.planNum }}</span
              >个名额
            </div>
          </div>
          <div class="job-divd"></div>
          <div class="train-user">
            <div>{{ item.companyName }}</div>
            <div>{{ item.reportTime }} 开课</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { queryJobsList, selectAlITrainplanNotePublishList } from "@/apis/index";
import { apiUrl } from "@/config";
export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
  data() {
    return {
      test: "",
      crewValue: "",
      options: [
        {
          value: "1",
          label: "船员招聘",
        },
        {
          value: "2",
          label: "船员培训",
        },
      ],
      value: "1",
      sortIndex: "0",
      jobList: [],
      total: 0,
      searchParams: {
        pageSize: 8,
        pageNo: 1,
        isSort: 0,
        positionCodeList: "",
      },
      trainList: [],
      scrollTop: 0,
      modifyStyle: false,
    };
  },
  mounted() {
    if (this.$route.params.positionOrCompany == "all") {
      this.searchParams.positionOrCompany = "";
    } else {
      this.searchParams.positionOrCompany =
        this.$route.params.positionOrCompany;
    }
    window.addEventListener("scroll", this.handleScroll);
    this.queryJobs();
    this.selectAlITrainplanNotePublish();
    // console.log(this.$route.params.positionOrCompany);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  created() {},
  methods: {
    //滑动更改样式
    handleScroll() {
      this.scrollTop = window.scrollY || document.documentElement.scrollTop;
      // console.log(this.scrollTop);
      if (this.scrollTop >= 300) {
        this.modifyStyle = true;
      } else {
        this.modifyStyle = false;
      }
    },
    //搜索框
    jobSearch() {
      if (this.value == 1) {
        this.searchParams.positionOrCompany = this.crewValue;
        this.queryJobs();
      } else if (this.value == 2) {
        if (this.crewValue != "") {
          this.$router.push({
            name: "trainDetail",
            params: { trainTitle: this.crewValue },
          });
        } else {
          this.$router.push({
            name: "trainDetail",
            params: { trainTitle: "all" },
          });
        }
      }
    },
    //最新 默认
    changeSort(type) {
      this.sortIndex = type;
      this.searchParams.isSort = type;
      this.queryJobs();
    },
    // 分页
    handleSizeChange(size) {
      this.searchParams.pageSize = size;
      // 调用后台接口或重新获取数据
      // this.selectRecordList();
      this.queryJobs();
    },
    handleCurrentChange(val) {
      this.searchParams.pageNo = val;
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      // 调用后台接口或重新获取数据
      // this.selectRecordList();
      this.queryJobs();
    },
    //职位
    async queryJobs() {
      const res = await queryJobsList(this.searchParams);
      // console.log(res);
      const list = res.data.resultList;
      if (list && list.length) {
        list.forEach((item) => {
          item.welfareTag = JSON.parse(item.welfareTag);
          // item.welfareTag = item.welfareTag.slice(0, 3);
          item.refreshTime = item.refreshTime.split(" ")[0];
          item.salaryBegin = (item.salaryBegin / 10000).toFixed(2);
          item.salaryEnd = (item.salaryEnd / 10000).toFixed(2);
          if (item.salaryBegin == 0 && item.salaryEnd == 0) {
            item.mianyi = "面议";
          }
        });
        this.jobList = list;
        this.total = res.data.rowCount;
      } else {
        this.jobList = [];
        this.total = 0;
      }
    },
    //培训
    async selectAlITrainplanNotePublish() {
      const res = await selectAlITrainplanNotePublishList({
        pageSize: 3,
        pageNo: 1,
      });
      res.data.resultList.forEach((item) => {
        // item.welfareTag = JSON.parse(item.welfareTag);
        item.reportTime = item.reportTime.split(" ")[0];
      });
      this.trainList = res.data.resultList;
      // console.log(res);
    },
    //招聘
    gotoJob(item) {
      if (
        sessionStorage.getItem("tolog") &&
        (sessionStorage.getItem("userType") == 0 ||
          sessionStorage.getItem("userType") == 5 ||
          sessionStorage.getItem("userType") == 4)
      ) {
        window.location.href = `${apiUrl}/crew_recruit_lsm/index.html#/frame/postDetail/${
          item.jobId
        }/?tolog=${sessionStorage.getItem("tolog")}`;
      } else {
        sessionStorage.clear();
        window.location.href = `${apiUrl}/crew_recruit_lsm/index.html#/frame/postDetail/${item.jobId}/?homeTitle=true`;
      }
    },
    navigateTo(url) {
      // 创建 XMLHttpRequest 对象
      var xhr = new XMLHttpRequest();

      // 监听请求状态变化
      xhr.onreadystatechange = function () {
        if (xhr.readyState === XMLHttpRequest.DONE) {
          if (xhr.status === 200) {
            // 请求成功，执行页面跳转
            window.location.href = url;
          } else {
            // 请求失败，执行错误处理逻辑
            console.error("请求失败");
          }
        }
      };

      // 发送 GET 请求
      xhr.open("GET", url, true);
      xhr.send();
    },
    //培训
    gotoTrain(item) {
      if (
        (sessionStorage.getItem("tolog") &&
          sessionStorage.getItem("userType") == 0) ||
        sessionStorage.getItem("userType") == 4 ||
        (sessionStorage.getItem("userType") == 1 &&
          sessionStorage.getItem("isLand") == 0)
      ) {
        window.location.href = `${apiUrl}/crew_train_lsm/index.html#/frame/courseDetail/${
          item.id
        }/0?tolog=${sessionStorage.getItem("tolog")}`;
        // window.location.href = `${apiUrl}/crew_train_lsm/index.html#/frame/courseDetail/${item.id}/0?homeTitle=true`;
      } else {
        sessionStorage.clear();
        window.location.href = `${apiUrl}/crew_train_lsm/index.html#/frame/courseDetail/${item.id}/0?homeTitle=true`;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
